import defaultClient from '@src/api/clients/default';

const URL = (path = '') => `app1/email-notifications/${path}`;

export function listEmailNotifications(clientSlug) {
  return defaultClient.request({ url: URL(`${clientSlug}/`) });
}

export function createEmailNotification(clientSlug, payload) {
  return defaultClient.request({ url: URL(`${clientSlug}/`), method: 'POST', payload });
}

export function updateEmailNotification(clientSlug, id, payload) {
  return defaultClient.request({ url: URL(`${clientSlug}/${id}/`), method: 'PATCH', payload });
}

export function deleteEmailNotification(clientSlug, id) {
  return defaultClient.request({ url: URL(`${clientSlug}/${id}/`), method: 'DELETE' });
}
